/** @format */
import { css } from 'styled-components';

import { StyledTrustpilotProps } from './index';
import { getTrustpilotDesktopMarginLeft } from './style-helpers';

export const styles = ({
    $marketLanguage,
    $isLeftAligned,
    $templateId,
}: StyledTrustpilotProps) => {
    return css`
        max-width: 100%;
        overflow: hidden;
        margin-left: ${getTrustpilotDesktopMarginLeft(
            $marketLanguage,
            $isLeftAligned,
            $templateId
        )};
    `;
};
